<template>
  <div class="page" :style="themeStyle">
    <div v-if="!loaded" class="loading">Loading</div>
    <div v-if="loaded" class="root">

      <!-- Single dramatic diagonal block -->
      <div class="diag-block"></div>

      <!-- Minimal nav -->
      <nav class="nav">
        <img v-if="loinfo && loinfo.main_logo" :src="loinfo.main_logo" class="nav-logo" />
        <div class="nav-center">
          <span class="nav-lo">{{ loName || "Loan Officer" }}</span>
          <span class="nav-rule"></span>
          <span class="nav-re">{{ realtorName || "Realtor" }}</span>
        </div>
        <a class="nav-apply" :href="applyRightLink">{{ heroPrimaryText }}</a>
      </nav>

      <!-- Content area -->
      <div class="content">

        <!-- Left: text -->
        <section class="text-col">
       
          <h1 class="headline" v-html="heroH1Html"></h1>
          <p class="body-copy">{{ heroBody }}</p>
          <div class="action-set">
            <a class="act-primary" :href="applyRightLink">{{ heroPrimaryText }}</a>
            <a v-if="applyLeftLink" class="act-text" :href="applyLeftLink">{{ heroSecondaryText }} →</a>
          </div>
          <div class="micro-links">
            <a v-if="loinfo && loinfo.phone_number" class="micro-link" :href="'tel:' + loinfo.phone_number">Call</a>
            <a v-if="loinfo && loinfo.email" class="micro-link" :href="'mailto:' + loinfo.email">Email</a>
            <a v-if="realtor && realtor.website_url" class="micro-link" :href="realtor.website_url" target="_blank" rel="noreferrer">Partner Site</a>
          </div>
        </section>

        <!-- Right: stacked minimal cards -->
        <section class="cards-col">

          <div class="mcard lo-mcard">
            <div class="mcard-label">Loan Officer</div>
            <div class="mcard-row">
              <img v-if="loinfo && loinfo.lo_image" :src="loinfo.lo_image" class="mcard-photo" />
              <div class="mcard-id">
                <div class="mcard-name">{{ loName }}</div>
                <div class="mcard-role">{{ loTitle }}</div>
                <div v-if="loinfo && loinfo.nmls" class="mcard-nmls">NMLS {{ (loinfo.nmls || "").trim() }}</div>
              </div>
            </div>
            <div class="mcard-sep"></div>
            <div class="mcard-reach">
              <a v-if="loinfo && loinfo.phone_number" :href="'tel:' + loinfo.phone_number" class="mcard-reach-link">{{ loinfo.phone_number }}</a>
              <a v-if="loinfo && loinfo.email" :href="'mailto:' + loinfo.email" class="mcard-reach-link">{{ loinfo.email }}</a>
            </div>
            <a class="mcard-cta" :href="applyRightLink">{{ heroPrimaryText }}</a>
          </div>

          <div class="mcard re-mcard">
            <div class="mcard-label re-lbl">Realtor Partner</div>
            <div class="mcard-row">
              <img v-if="realtor && realtor.headshot_url" :src="realtor.headshot_url" class="mcard-photo" />
              <div class="mcard-id">
                <div class="mcard-name">{{ realtorName }}</div>
                <div class="mcard-role">{{ realtor && realtor.brokerage_name ? realtor.brokerage_name : "" }}</div>
              </div>
            </div>
            <div class="mcard-sep re-sep"></div>
            <div class="mcard-reach">
              <a v-if="realtor && realtor.phone_number" :href="'tel:' + realtor.phone_number" class="mcard-reach-link re-rl">{{ realtor.phone_number }}</a>
              <a v-if="realtor && realtor.email" :href="'mailto:' + realtor.email" class="mcard-reach-link re-rl">{{ realtor.email }}</a>
              <a v-if="realtor && realtor.website_url" :href="realtor.website_url" class="mcard-reach-link re-rl" target="_blank" rel="noreferrer">Website</a>
            </div>
          </div>

        </section>
      </div>

    </div>
  </div>
</template>

<script>
import coBrandMixin from "../../mixins/coBrandMixin.js";
const BRAND_COLORS = {
  zonalending: { primary: "#eb610a", accent: "#646363" },
  radiantmortgage: { primary: "#1C1F39", accent: "#DB9457" },
  conradmortgage: { primary: "#4a4b4b", accent: "#d4af37" },
  theimgteam: { primary: "#ff6633", accent: "#4a4c54" },
  responsivemortgage: { primary: "#07212c", accent: "#FF7F47" },
  kpmortgage: { primary: "#0D2821", accent: "#34BFC6" },
  ignitemortgage: { primary: "#000000", accent: "#00b1eb" },
  goldstarfinancial: { primary: "#0b1726", accent: "#c69c39" },
};
function getBrandKey(email) {
  if (!email) return null;
  const d = email.slice(email.indexOf("@") + 1).toLowerCase();
  return d.split(".")[0] || null;
}
export default {
  name: "CoBrandStudio",
  mixins: [coBrandMixin],
  computed: {
    brandKey() { const k = getBrandKey(this.loinfo?.email); return (k && BRAND_COLORS[k]) ? k : "goldstarfinancial"; },
    palette() { return BRAND_COLORS[this.brandKey] || BRAND_COLORS.goldstarfinancial; },
    themeStyle() { return { "--p": this.palette.primary, "--a": this.palette.accent }; },
    
    heroH1Html() {
      const h = (this.realtor?.header1 || this.loinfo?.header1 || "").trim();
      if (!h) return "Ready to get<br/><em>started?</em>";
      const parts = h.split(",");
      if (parts.length > 1) {
        const a = parts[0].trim();
        const b = parts.slice(1).join(",").trim();
        return `${a}<br/><em>${b}</em>`;
      }
      return h;
    },
    
    heroHeading() { return this.loinfo?.text_section_heading || "About"; },
    heroPrimaryText() { return this.loinfo?.right_button_text || "Apply Now"; },
    heroSecondaryText() { return this.loinfo?.left_button_text || "Schedule Appointment"; },
    heroBody() {
      const p = [this.loinfo?.text_section_body_p1, this.loinfo?.text_section_body_p2].filter(Boolean).join(" ").trim();
      return p || this.loinfo?.footer_slogan || "Start your application in minutes and we'll guide you from application through closing.";
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:wght@300;400;500&display=swap');

.page {
  min-height: 100vh;
  background: #ffffff;
  color: #111111;
  font-family: 'DM Sans', sans-serif;
  --p: #0b1726;
  --a: #c69c39;
  --hairline: rgba(17,17,17,0.10);
  --muted: #6b7280;
  --a-tint: color-mix(in srgb, var(--a) 10%, #ffffff);
  position: relative;
  overflow: hidden;
}
.root { position: relative; z-index: 1; min-height: 100vh; display: flex; flex-direction: column; }

/* THE DIAGONAL BLOCK — this is the signature, everything else is restraint */
.diag-block {
  position: fixed;
  top: -20%;
  right: -5%;
  width: 52%;
  height: 160%;
  background: color-mix(in srgb, var(--p) 4%, #ffffff);
  transform: rotate(-8deg);
  transform-origin: top right;
  pointer-events: none;
  z-index: 0;
  border-left: 2px solid color-mix(in srgb, var(--a) 25%, transparent);
}
.diag-block::after {
  content: "";
  position: absolute; inset: 0;
  background: linear-gradient(180deg,
    color-mix(in srgb, var(--a) 8%, transparent) 0%,
    transparent 50%,
    color-mix(in srgb, var(--a) 4%, transparent) 100%);
}

/* NAV */
.nav {
  display: flex; align-items: center; justify-content: space-between;
  padding: 24px 48px;
  border-bottom: 1px solid var(--hairline);
  position: relative; z-index: 10;
}
.nav-logo { height: 34px; object-fit: contain; }
.nav-center { display: flex; align-items: center; gap: 14px; font-size: 13px; }
.nav-lo { font-weight: 500; color: var(--p); }
.nav-rule { width: 1px; height: 14px; background: var(--hairline); }
.nav-re { color: var(--muted); font-weight: 300; }
.nav-apply {
  font-size: 13px; font-weight: 500; text-decoration: none;
  color: var(--p); border: 1px solid var(--hairline);
  padding: 9px 20px; border-radius: 6px;
  transition: background 0.18s, border-color 0.18s;
}
.nav-apply:hover { background: color-mix(in srgb, var(--p) 4%, #fff); border-color: color-mix(in srgb, var(--p) 18%, transparent); }

/* CONTENT */
.content {
  display: grid; grid-template-columns: 1fr 420px;
  gap: 0; flex: 1; position: relative; z-index: 1;
  max-width: 1160px; margin: 0 auto; width: 100%;
  padding: 0 48px;
  align-items: center;
  min-height: calc(100vh - 83px);
}

/* TEXT COL */
.text-col { padding: 60px 60px 60px 0; }
.eyebrow {
  display: block; font-size: 11px; font-weight: 500;
  letter-spacing: 0.22em; text-transform: uppercase;
  color: var(--a); margin-bottom: 20px;
}
.headline {
  font-family: 'DM Serif Display', serif;
  font-size: clamp(48px, 6vw, 80px);
  font-weight: 400; line-height: 1.0;
  color: var(--p); margin: 0 0 24px;
  letter-spacing: -0.02em;
}
.body-copy { font-size: 15px; line-height: 1.75; color: var(--muted);  margin-bottom: 32px; font-weight: 300; }
.action-set { display: flex; align-items: center; gap: 20px; flex-wrap: wrap; margin-bottom: 24px; }
.act-primary {
  font-size: 14px; font-weight: 500; text-decoration: none;
  background: var(--p); color: #fff;
  padding: 13px 28px; border-radius: 7px;
  transition: opacity 0.18s;
}
.act-primary:hover { opacity: 0.88; }
.act-text {
  font-size: 14px; font-weight: 400; text-decoration: none;
  color: var(--muted); transition: color 0.18s;
}
.act-text:hover { color: var(--p); }
.micro-links { display: flex; gap: 16px; }
.micro-link {
  font-size: 12px; font-weight: 400; text-decoration: none;
  color: var(--muted); border-bottom: 1px solid var(--hairline);
  padding-bottom: 1px; transition: color 0.18s, border-color 0.18s;
}
.micro-link:hover { color: var(--p); border-color: var(--p); }

/* CARDS COL */
.cards-col { padding: 60px 0; display: flex; flex-direction: column; gap: 12px; }

.mcard {
  background: #fff; border: 1px solid var(--hairline);
  border-radius: 16px; padding: 22px;
  box-shadow: 0 2px 20px rgba(17,17,17,0.04);
  position: relative; overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
}
.mcard:hover { box-shadow: 0 6px 28px rgba(17,17,17,0.08); transform: translateY(-1px); }

/* Diagonal corner pip */
.mcard::before {
  content: "";
  position: absolute; bottom: 0; right: 0;
  width: 0; height: 0;
  border-style: solid;
  border-width: 0 0 36px 36px;
  border-color: transparent transparent color-mix(in srgb, var(--p) 8%, #fff) transparent;
}
.re-mcard::before { border-color: transparent transparent color-mix(in srgb, var(--a) 12%, #fff) transparent; }

.mcard-label {
  font-size: 10px; font-weight: 500; letter-spacing: 0.2em;
  text-transform: uppercase; color: var(--muted);
  margin-bottom: 14px;
}
.re-lbl { color: color-mix(in srgb, var(--a) 75%, var(--p)); }

.mcard-row { display: flex; gap: 14px; align-items: center; }
.mcard-photo { width: 56px; height: 56px; border-radius: 10px; object-fit: cover; }
.mcard-name { font-size: 18px; font-weight: 500; color: var(--p); letter-spacing: -0.01em; }
.mcard-role { font-size: 12px; color: var(--muted); margin-top: 3px; }
.mcard-nmls { font-size: 11px; color: color-mix(in srgb, var(--muted) 65%, transparent); margin-top: 2px; }

.mcard-sep {
  height: 1px; background: var(--hairline); margin: 14px 0;
  position: relative;
}
.mcard-sep::before {
  content: "";
  position: absolute; top: -1px; left: 0;
  height: 3px; width: 50px;
  background: var(--p);
  clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
}
.re-sep::before { background: var(--a); }

.mcard-reach { display: flex; flex-direction: column; gap: 4px; margin-bottom: 14px; }
.mcard-reach-link {
  font-size: 12px; text-decoration: none; color: var(--muted);
  transition: color 0.18s;
}
.mcard-reach-link:hover { color: var(--p); }
.re-rl:hover { color: color-mix(in srgb, var(--a) 80%, var(--p)); }

.mcard-cta {
  display: block; text-align: center; text-decoration: none;
  background: var(--p); color: #fff;
  font-size: 13px; font-weight: 500; padding: 10px;
  border-radius: 8px; transition: opacity 0.18s;
}
.mcard-cta:hover { opacity: 0.88; }

@media (max-width: 820px) {
  .content { grid-template-columns: 1fr; padding: 0 24px; min-height: auto; }
  .text-col { padding: 40px 0 20px; }
  .cards-col { padding: 0 0 40px; }
  .nav { padding: 18px 24px; }
  .nav-center { display: none; }
}
</style>
